import { inject } from 'vue';
import { preconToastsOptionsInjectionKey } from '../symbols';
import {
    type NormalizedPreconToastsGlobalOptions,
    normalizePreconToastsOptions,
} from '../options';

/**
 * Composable that injects the library options into a component.
 *
 * @param override Override the global option values.
 */
export function usePreconToastsOptions(): NormalizedPreconToastsGlobalOptions {
    // This injects global options from the application into the component that uses this composable.
    return inject(
        preconToastsOptionsInjectionKey,
        normalizePreconToastsOptions,
        true
    );
}
